export default (axios, { hash }) => axios.post('/wallet/', { hash });
